import { render } from "./DealerSelect.vue?vue&type=template&id=58352279&scoped=true"
import script from "./DealerSelect.vue?vue&type=script&lang=js"
export * from "./DealerSelect.vue?vue&type=script&lang=js"

import "./DealerSelect.vue?vue&type=style&index=0&id=58352279&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58352279"]])

export default __exports__